import NextImage from "next/image";
import React from "react";

import { verticalProductCardBadge } from "./VerticalProductCard.css";
import type { ProductCardDataType } from "./types";

type Props = {
  product: Pick<ProductCardDataType, "badge" | "image">;
};

export const VerticalProductCardBadge: React.FC<Props> = ({ product }) => {
  if (!product.badge) return null;
  if (!product.image.src) return null;
  if (!product.badge.src) return null;

  return (
    <div className={verticalProductCardBadge}>
      <NextImage
        src={product.badge.src}
        alt={product.badge.alt}
        width={200}
        height={200}
      />
    </div>
  );
};
